import { Type } from '@angular/core';

import { PostalComponent } from '../components/postal/postal.component';
import { ProductRecommendationComponent } from '../components/product-recommendation/product-recommendation.component';
import { AnswerConfirmationComponent } from '../components/answer-confirmation/answer-confirmation.component';
import { StepComponent } from '../components/step/step.component';
import { VisualizerComponent } from '../components/visualizer/visualizer/visualizer.component';
import { WelcomeComponent } from '../components/welcome/welcome.component';

class Dictionary {
    constructor(public name: string, public component: Type<any>) { }
}

export class ComponentMap {
    private static components: Dictionary[] = [
        new Dictionary('WelcomeComponent', WelcomeComponent),
        new Dictionary('AnswerConfirmationComponent', AnswerConfirmationComponent),
        new Dictionary('StepComponent', StepComponent),
        new Dictionary('VisualizerComponent', VisualizerComponent),
        new Dictionary('PostalComponent', PostalComponent),
        new Dictionary('ProductRecommendationComponent', ProductRecommendationComponent)

    ];
    public static GetComponents() {
        return this.components.map(x => x.component);
    }
    public static GetComponentByName(name: Type<any>) {
        const component = this.components.filter(x =>
            x.name === name.toString()
        );
        if (component.length > 0) {
            return component[0].component;
        } else {
            return WelcomeComponent;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/models/component.map.ts